import { ServerMessagePayload } from '@common/api';
import { EntityClickedEvent } from '@common/events';

import { ClientEventSystem } from './ClientBase';

/**
 * Debug system that logs entity click events to the console.
 * Useful for inspecting entity IDs during development.
 */
export class EntityClickDebugSystem extends ClientEventSystem<'EntityClicked'> {
  public eventTypes: 'EntityClicked'[] = ['EntityClicked'];

  handleEvent(event: EntityClickedEvent): ServerMessagePayload[] {
    const { clientEntityId } = event.payload;
    const world = this.getWorld();
    const networkIdentity = world.getComponent(clientEntityId, 'NetworkIdentity');

    // Default to 'unknown' if the entity or component no longer exists
    // This can happen if the entity was destroyed during the 1-tick deferral
    const serverEntityId = networkIdentity?.serverID ?? 'unknown';

    console.log(`Entity clicked - Client ID: ${clientEntityId}, Server ID: ${serverEntityId}`);

    // Select the entity in the inspector if it's already open
    if (this.clientServices.entityInspector.state.isOpen) {
      this.clientServices.entityInspector.selectEntity(clientEntityId);
    }

    return [];
  }
}
